import { render, staticRenderFns } from "./Verify1.vue?vue&type=template&id=2133e8ea&scoped=true&"
import script from "./Verify1.vue?vue&type=script&lang=js&"
export * from "./Verify1.vue?vue&type=script&lang=js&"
import style0 from "./Verify1.vue?vue&type=style&index=0&id=2133e8ea&scoped=true&lang=css&"
import style1 from "./Verify1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2133e8ea",
  null
  
)

export default component.exports